import _ from 'lodash';

// Data Labels are used to specify which data field to use at predefined places in
// the form. For example, the data field "englishName" containing "Kötbullar" is
// displayed in the header above the form.
//
// A default set of data labels are specified. They can be overridden by
// specifying either:
//   1) a string which points to the data field to select the value
//   2) a function which returns the desired value

const defaultDataLabels = {
  title: 'title',
  titleContext: () => null,
  status: 'status',
  modifiedDate: 'modifyDate',
  modifiedBy: 'modifiedBy'
};

function getDataLabels(data = {}, dataLabels = {}, language) {
  const combinedDataLabels = {
    ...defaultDataLabels,
    ...dataLabels
  };

  const labels = {};
  Object.keys(defaultDataLabels).forEach(labelKey => {
    const resolver = combinedDataLabels[labelKey];
    let label;
    if (_.isFunction(resolver)) {
      // Use function to resolve label
      label = resolver(data, { language });
    } else {
      // Use string to lookup label in the data
      label = _.get(data, resolver);
    }
    labels[labelKey] = label;
  });

  return labels;
}

export default getDataLabels;

export { defaultDataLabels };
